import {
  getSignatureStatus,
  hasSignedEnrollmentAgreement
} from '../../utils/utils'
import type { SignatureState } from '../../types'

type ApplyHydratedSignatureStateArgs = {
  state: SignatureState
  setSignatureStatus: (value: string | null) => void
  setIsSignatureSigned: (value: boolean) => void
  setSignatureCompleted: (completed: boolean) => void
}

export function applyHydratedSignatureState({
  state,
  setSignatureStatus,
  setIsSignatureSigned,
  setSignatureCompleted
}: ApplyHydratedSignatureStateArgs) {
  const signatureStatus = getSignatureStatus(state)
  const isSigned = hasSignedEnrollmentAgreement(state)

  setSignatureStatus(signatureStatus)
  setIsSignatureSigned(isSigned)

  if (isSigned) {
    setSignatureCompleted(true)
  }
}
